<div style="min-height: 80vh;max-width: 90vw;" class="box-404 m-auto d-flex align-items-center flex-column justify-content-center">
  <div class="bg-white box-404 p-4 rounded-lg shadow-lg text-center w-100" style="max-width: 400px; max-height: 400px; display: flex; align-items: center; flex-direction: column; justify-content: center;">
      <div class="my-4">
          <img src="../../../assets/logos/logo-blue.svg" alt="Blukit logo" style="height: 70px;">
      </div>
      <h1 class="text-404 font-weight-bold  mb-2">404</h1>
      <p class="text-xl mt-4 text-secondary">Página não encontrada!</p>
  </div>

  <div class="useful-links mt-4">
      <a href="/" class="d-block">Página Inicial</a>
  </div>
</div>
